/* =============================================================
   IMPULSE NUTRITION — Landing Pages — Add To Cart (génération 3)
   assets/lp3-atc.js
   -------------------------------------------------------------
   Générique : tout élément portant la classe `.lp3-atc-trigger`
   et un attribut `data-variant-id` devient un bouton d'ajout au
   panier. Aucun ID produit codé en dur.

   Attributs lus sur le bouton
     data-variant-id     obligatoire
     data-quantity       défaut 1
     data-price          prix numérique, pour le dataLayer
     data-product-name   nom produit, pour le dataLayer
     data-category       catégorie, pour le dataLayer
     data-location       emplacement du CTA (lp_location dans GA4)
   ============================================================= */

(function () {

  function feedback(btn, state) {
    var label = btn.querySelector('.lp3-atc__top, .lp3-atc-label');
    var price = btn.querySelector('.lp3-atc__prices');
    var icon  = btn.querySelector('.lp3-atc__icon');
    var isStructured = !!label;

    if (state === 'loading') {
      if (isStructured) {
        if (!btn.getAttribute('data-orig')) {
          btn.setAttribute('data-orig', label.textContent.trim());
        }
        label.textContent = 'Ajout en cours…';
        if (price) price.style.visibility = 'hidden';
        if (icon)  icon.style.opacity = '.4';
      } else {
        if (!btn.getAttribute('data-orig')) {
          btn.setAttribute('data-orig', btn.textContent.trim());
        }
        btn.textContent = 'Ajout en cours…';
      }
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '.85';

    } else if (state === 'success') {
      if (isStructured) {
        label.textContent = '✓ Ajouté au panier';
        if (icon) icon.style.opacity = '1';
      } else {
        btn.textContent = '✓ Ajouté au panier';
      }
      btn.style.opacity = '1';

    } else if (state === 'error') {
      var orig = btn.getAttribute('data-orig') || 'Ajouter au panier';
      if (isStructured) {
        label.textContent = 'Erreur — réessayer';
        if (price) price.style.visibility = '';
        if (icon)  icon.style.opacity = '1';
      } else {
        btn.textContent = 'Erreur — réessayer';
      }
      btn.style.opacity = '1';
      setTimeout(function () {
        if (isStructured) { label.textContent = orig; }
        else { btn.textContent = orig; }
        btn.style.pointerEvents = '';
      }, 2500);
    }
  }

  function track(btn, variantId, qty) {
    if (!window.dataLayer) return;
    var price = parseFloat(btn.getAttribute('data-price')) || 0;
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: 'EUR',
        value: price * qty,
        items: [{
          item_id: String(variantId),
          item_name: btn.getAttribute('data-product-name') || 'Produit Impulse',
          item_category: btn.getAttribute('data-category') || '',
          price: price,
          quantity: qty
        }]
      },
      lp_location: btn.getAttribute('data-location') || 'lp_unknown'
    });
  }

  function addToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var qty = parseInt(btn.getAttribute('data-quantity'), 10) || 1;

    if (!variantId || variantId === '0') {
      console.warn('[LP3 ATC] data-variant-id manquant.');
      return;
    }

    track(btn, variantId, qty);
    feedback(btn, 'loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    })
    .then(function () {
      feedback(btn, 'success');
      // Mécanisme du thème : le flag déclenche l'ouverture du
      // cart drawer au rechargement de la page.
      try { sessionStorage.setItem('impulse_open_cart_drawer', '1'); } catch (e) {}
      /* Prospect : applique le code promo avant le rechargement (défini par lp2-hero) */
      var lpDiscount = window.impulseApplyProspectDiscount ? window.impulseApplyProspectDiscount() : Promise.resolve();
      var lpDelay = new Promise(function (r) { setTimeout(r, 1200); });
      Promise.all([lpDiscount, lpDelay]).then(function () { window.location.reload(); });
    })
    .catch(function (err) {
      console.error('[LP3 ATC]', err);
      feedback(btn, 'error');
    });
  }

  function bind(el) {
    if (el.getAttribute('data-atc-bound') === '1') return;
    el.setAttribute('data-atc-bound', '1');
    el.addEventListener('click', function (e) {
      e.preventDefault();
      addToCart(el);
    });
  }

  function init() {
    document.querySelectorAll('.lp3-atc-trigger[data-variant-id]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

})();
